export default {
      id: "reefer-status-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#reefer-status",
      toString: function () {
        return this.url;
      }
    }